import API from '../../../manager/API';
import { dispatch } from '../../hooks';
import slice from './slice';

const { setDataProcessingMergeProgressData } = slice.actions;

const getDataProcessingMergeProgress = (url: any) => async () => {
  try {
    const response = await API.dataProcessingMergeProgress.dataProcessingMergeProgress(url);
    dispatch(setDataProcessingMergeProgressData(response.data));
    return { response, status: response.status, data: response.data };
  } catch (error) {}
};

export default {
  getDataProcessingMergeProgress
};
